import React from "react";
import "../styles/Contact.css";

function Contact() {
  console.log("Image clicked");
  return (
    <div id="contact">
      <div className="contact-background">
        <div className="contact-container">
          <a
            href="https://www.linkedin.com/in/yulia-fln/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://cdn-icons-png.flaticon.com/512/61/61109.png"
              alt="LinkedIn logo"
              className="footerLinkImg"
            />
          </a>

          <a href="https://github.com/yuliaFl">

            <img
              src="/github.svg"
              alt="Github logo"
              className="footerLinkImg"
            ></img>
          </a>
          <div className="footer-bottom">
            <p>&copy; Yulia Flenova | 2026</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
